import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { registerServiceWorker } from './services/pushService';
import { captureInstallPrompt } from './services/installPrompt';


const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

// Рендерите ваше приложение с использованием нового API
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Предложение установки (Chromium) приходит рано и один раз — ловим до рендера
captureInstallPrompt();

// Service worker — только для web push (без кешей); в Telegram и dev-сборке не регистрируется
registerServiceWorker();
